import { render, staticRenderFns } from "./ProfissionalForm.vue?vue&type=template&id=5e65a47f"
import script from "./ProfissionalForm.vue?vue&type=script&lang=js"
export * from "./ProfissionalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports